import React, { useState, useEffect } from 'react'
import { useSlate, ReactEditor } from 'slate-react'
import { Transforms, Editor } from 'slate'

import { changeCellBackgroundColor, BLOCK_TABLE_CELL } from '../Canvas/TratoFormat'
import { ToolbarColorPicker } from './BackgroundColorButton'

export const MARK_TABLE_BACKGROUND_COLOR = 'cellBackgroundColor';

export default function TableBackgorundColorButton({ isDisabled }) {
  const [currentColor, setCurrentColor] = useState('#000')
  const [mark, setMark] = useState(null);
  const editor = useSlate()
  const { selection } = editor;

  useEffect(() => {
    const matched = Array.from(Editor.nodes(editor, {
      match: n => n.type === BLOCK_TABLE_CELL,
    }));
    if (matched && matched.length) {
      const [node] = matched[0]
      const backgroundColor = node?.[MARK_TABLE_BACKGROUND_COLOR] ? node[MARK_TABLE_BACKGROUND_COLOR] : '#000'
    
      return setCurrentColor(backgroundColor)
    }
    
    setCurrentColor('#000')
  }, [editor, selection])

  const handleClick = (evt) => {
    evt.preventDefault();
    const { selection } = editor;
    setMark(selection);
  };

  const handleChange = (color, e) => {
    e.preventDefault()
    e.stopPropagation();
    const { selection } = editor;
    
    if (mark) {
      ReactEditor.focus(editor);
      Transforms.select(editor, mark);

      changeCellBackgroundColor(editor, color.hex)
    }

    setCurrentColor(color.hex)
  };

  return (
    <ToolbarColorPicker 
      icon="fill"
      currentColor={currentColor}
      onClick={handleClick}
      onColorChange={handleChange}
      isDisabled={isDisabled}
    />
  )
}
